import axios from "axios";

const requiredEnvVariables = ['REACT_APP_COUNTRY','REACT_APP_URL_BACK'];
const missingVariables = requiredEnvVariables.filter((variable) => !process.env[variable]);
if (missingVariables.length > 0) {
  alert('Falta configuración de variables de entorno de la aplicación, comuníquese con soporte');
}

if(process.env.NODE_ENV === 'development'){
  window.$urlBack = (process.env.REACT_APP_URL_BACK !== '')? process.env.REACT_APP_URL_BACK : 'http://sirmovil.test';
  window.$location = (process.env.REACT_APP_COUNTRY !== '')? process.env.REACT_APP_COUNTRY : 'ECU';
}else{
  window.$urlBack =  process.env.REACT_APP_URL_BACK;
  window.$location = process.env.REACT_APP_COUNTRY;
}

axios.defaults.baseURL = window.$urlBack;
axios.interceptors.request.use( (config) => {
    const token_seguridad = sessionStorage.getItem('token');
    if (token_seguridad) {
      config.headers.Authorization = 'Bearer ' + token_seguridad;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

axios.interceptors.response.use(
  response => response,
  error => {
    if (error.response.status === 401) {
      sessionStorage.clear();
      window.parent.location = '/';
      let data = {
        response: false,
        data: [],
        headers: [],
        alert: '',
        messages: ['Acceo no autorizado']
      }
      return {data: data};
    } else if (error.response.status === 500){
      let data = {
        response: false,
        data: [],
        headers: [],
        alert: '',
        messages: ['Ocurrio un error de comunicacion con el servidor comuniquese con soporte'],
        offline: true
      }
      return {data: data};
    }
});

const requestGenerico = {
  get: (url) => axios.get(url),
  post: (url, body) => axios.post(url, body),
  put: (url, body) => axios.put(url, body),
  delete: (url) => axios.delete(url),
};

export default requestGenerico;
